<template>
  <section>
    <h1>{{ $t("3rdPartyLicenses") }}</h1>
  </section>

  <section>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6">
        <div id="licenseAccordion" class="accordion">
          <div
            v-for="(library, key, index) in libraries"
            :key="index"
            class="accordion-item"
          >
            <h2 :id="`heading${index}`" class="accordion-header">
              <button
                :aria-controls="`collapse${index}`"
                :data-bs-target="`#collapse${index}`"
                aria-expanded="false"
                class="accordion-button collapsed shadow-none"
                data-bs-toggle="collapse"
                type="button"
              >
                {{ library.name }}
              </button>
            </h2>
            <div
              :id="`collapse${index}`"
              :aria-labelledby="`heading${index}`"
              class="accordion-collapse collapse"
              data-bs-parent="#licenseAccordion"
            >
              <div class="accordion-body">
                <div>
                  <h4 class="mb-1">{{ library.name }}</h4>
                  <span class="text-muted">Version {{ library.version }}</span>
                </div>

                <div class="mt-4">
                  <h5 class="mb-1">License</h5>
                  {{ library.licenses }}
                </div>

                <div class="mt-4" v-if="library.publisher">
                  <h5 class="mb-1">Publisher</h5>
                  <a :href="library.url" target="_blank">
                    {{ library.publisher }}
                  </a>
                </div>

                <div class="mt-4" v-if="library.repository">
                  <h5 class="mb-1">Repository</h5>
                  <a :href="library.repository" target="_blank">
                    {{ library.repository }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import licenses from "../assets/licenses.json";

export default {
  name: "Licenses",
  data() {
    return {
      libraries: licenses,
    };
  },
};
</script>

<style scoped></style>
